import { Container } from "react-bootstrap";
import { Provider } from "react-redux";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/navbar/Navbar";
import Dashboard from "./pages/dashboard/Dashboard";
import Login from "./pages/login/Login";
import Logout from "./pages/logout/Logout";
import Nominee from "./pages/nominee/Nominee";
import Register from "./pages/register/Register";
import store from './store/store';

function App() {
  const links = [
    {
      name: "Login",
      url: "/login",
    },

    {
      name: "Register",
      url: "/register",
    },
  ];

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Navbar menu={links} />
        <div className="body-content">
          <Container>
            <Switch>
              <Route path="/register" exact component={Register} />
              <Route path="/" exact component={Login} />
              <Route path="/login" exact component={Login} />
              <Route path='/dashboard' exact component={Dashboard} />
              <Route path='/logout' exact component={Logout} />
              <Route path='/nominee/:userId' component={Nominee} />
              <Route path='/nominee' component={Nominee} />

            </Switch>
          </Container>
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
